<div class="layout-wrapper landing section intro-section pb-0">
  <div class="about-us-page" [dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">

    <!-- Hero Section -->
    <section class="about-hero-section" style="text-align:center; padding: 4rem 0rem 0rem 2rem; background-color: #f0f4ff;">
      <h1 class="hero-heading">{{ 'aboutUs.heroSection.title' | translate }}</h1>
      <p class="hero-subtitle">{{ 'aboutUs.heroSection.subtitle' | translate }}</p>
      <p class="hero-description" [innerHTML]="'aboutUs.heroSection.description' | translate | replace:'\n':'<br>' | safeHtml">
      </p>
      <!-- Optional hero image -->
      <img src="assets/images/dojo/hero-illustration.png" alt="Hero Illustration" class="img-fluid mt-4" />
    </section>
  
    <!-- “What’s Our Platform?” Section -->
    <section  class="about-whats-platform" style="padding: 3rem 2rem; background-color: #fff;">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-4 mb-lg-0">
            <img src="assets/images/dojo/what-is.jpg" 
                 alt="{{ 'teacher.page.about.heading' | translate }}" 
                 class="img-fluid rounded">
          </div>
          <div class="col-lg-6">
            <h2 >{{ 'aboutUs.whatsPlatform.title' | translate }}</h2>
            <p class="mt-3" [innerHTML]="'aboutUs.whatsPlatform.description' | translate | replace:'\n':'<br>' | safeHtml"></p>

          </div>
        </div>
      </div>
    </section>

    <!-- Built on lots of LOVE / Testimonials Section -->
    <section class="about-love-section" style="padding: 3rem 2rem; background-color: #f7f9fa;">
      <div class="container text-center">
        <h2>{{ 'aboutUs.builtOnLove.title' | translate }}</h2>
        <p class="mt-3">{{ 'aboutUs.builtOnLove.subtitle' | translate }}</p>
        
        <!-- Grid of small testimonials or images -->
        <div class="row mt-5">
          <div class="col-md-4 mb-4" *ngFor="let testimonial of [1,2,3]">
            <div class="testimonial-card p-3 bg-white d-flex align-items-center">
              <img src="assets/images/dojo/std{{ testimonial }}.jpg" alt="User" class="img-fluid rounded-circle me-2" style="max-width:100px;">
              <p class="mb-0">{{ 'aboutUs.builtOnLove.testimonials.testimonial' + testimonial | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  
    <!-- We Believe In... Section -->
    <section class="about-beliefs-section" style="padding: 3rem 2rem; background-color: #fff;">
      <div class="container text-center">
        <h2>{{ 'aboutUs.weBelieve.title' | translate }}</h2>
        <div class="row mt-4">
          <div class="col-md-6 mb-4" *ngFor="let item of [1,2,3,4]">
            <h5>{{ 'aboutUs.weBelieve.bullet' + item + '.title' | translate }}</h5>
            <p>{{ 'aboutUs.weBelieve.bullet' + item + '.description' | translate }}</p>
          </div>
        </div>
      </div>
    </section>
  
    <!-- What our team says Section -->
    <!-- <section class="about-team-section" style="padding: 3rem 2rem; background-color: #f7f9fa;">
      <div class="container text-center">
        <h2>{{ 'aboutUs.teamSays.title' | translate }}</h2>
        <div class="row mt-4">
          <div class="col-md-4 mb-4" *ngFor="let teamMember of [1,2,3]">
            <div class="team-card p-3 bg-white">
              <img src="assets/images/aboutus/team-member-{{ teamMember }}.jpg" alt="Team Member" class="img-fluid rounded-circle mb-2" style="max-width:100px;">
              <h5>{{ 'aboutUs.teamSays.member' + teamMember + '.name' | translate }}</h5>
              <p class="text-muted">{{ 'aboutUs.teamSays.member' + teamMember + '.role' | translate }}</p>
              <p>{{ 'aboutUs.teamSays.member' + teamMember + '.description' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  
    <!-- Final Tagline -->
    <section class="about-tagline-section" style="padding: 3rem 2rem; background-color: #fff; text-align:center;">
      <h3>{{ 'aboutUs.finalTagline' | translate }}</h3>
    </section>
  
  </div>
  
</div>
